import { React, useState } from 'react';
import Box from '@iso/components/utility/box';
import ContentHolder from '@iso/components/utility/contentHolder';
import Button from '@iso/components/uielements/button';
import { useContext } from 'react';
import { Form, Input, Switch } from 'antd';
import closeIcon from '@iso/assets/images/icon/07-icon.svg';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AppContext } from '../../../context/ContextProvider';
import Select from '../../Deployments/Deployment.styles';
import { customFilterOption, customSortOptions, hasPermission, isValidAny, isValidBool, isValidListString, isValidMapAny, isValidMapString } from '../../../context/helper';
import CustomInfoTooltip from '../../Dashboard/CustomComponents/CustomInfoTooltip';
import { AlertContext } from '../../../context/alertContext';

const { TextArea } = Input;

const ProdContentHold = styled.div`
  .isoBoxWrapper {
    height: auto;
    border: none;
    margin: 0;
  }

  .isoHelperText {
    color: red;
    font-weight: 400;
    font-size: 12px;
    margin-top: 10%;
    display: flex;
    justify-content: start;
  }

  .header-text{
    font-size: 14px;
  }
`;

let titleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontSize: "16px",
    fontWeight: "500"
}

let subTitleStyle = {
    fontSize: "14px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontType: "regular",
    fontWeight: "400"
}

export default ({
    data,
    allData,
    update,
    service,
    type,
    fromWorkflow,
    fromApplicationBlueprint,
    setEnvVarsList,
    accountDetails,
    setAccountDetails,
}) => {

    const { openRightDrawer, setOpenRightDrawer } = useContext(AppContext);
    const [form] = Form.useForm();
    const { set_alertOptions } = useContext(AlertContext);

    // Check if accountDetails has account_id (secret manager is configured)
    const hasSecretManager = accountDetails && typeof accountDetails === 'object' && accountDetails !== "Atmosly" && accountDetails.account_id;

    const [envData, setEnvData] = useState(update ?
        { 
            ...data, 
            value: hasPermission('view_secret') && data.isSecret ? data.value : !data.isSecret ? data.value : "********", 
            lastAction: "Update",
            originalKey: data.originalKey || data.varName
        }
        : {
            varName: "",
            valueFrom: fromWorkflow ? "Value" : "",
            valueShown: "",
            value: "",
            originalKey: "",
            lastAction: "",
            isSecret: false,
            isHide: false,
            dependOn: "",
            value_depend_on: "",
            error: false,
            importFrom: "",
            syncProj: false,
            injectAt: fromWorkflow ? ["Build Time"] : []
        });
    const [error, setError] = useState({
        status: false,
        msg: "Success"
    });
    const [hasChanges, setHasChanges] = useState(false);

    useEffect(() => {
        if (form) {
            form.setFieldsValue({ ...envData });
        }
    }, [envData]);

    useEffect(() => {
        if (update && form) {
            try {
                const values = form.validateFields();
                console.log('Success:', values);
            }
            catch (err) {
                console.log('Error :', err);
            }
        }
    }, [update]);

    const handelClick = () => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
                columnId: ""
            },
        });
    }

    const handelInputChange = (e) => {
        console.log("inside handelInputChange");
        let val = e.target.value;
        if (e.target.name === "value" && ["map(any)", "map(string)", "any", "list(string)"].includes(envData.type)) {
            // pass - allow spaces for complex types
        }
        else if (e.target.name !== "value") {
            val = val.replace(/\s/g, '');
        }

        if (e.target.name === "value") {
            console.log("Env data: ", envData);
            setEnvData({
                ...envData,
                [e.target.name]: val,
                dependOn: null,
                error: val ? false : true
            });
        }
        else {
            if (e.target.name === "varName") {
                if (!update) {
                    setEnvData({ ...envData, [e.target.name]: val, error: val ? false : true, originalKey: val });
                }
                else {
                    setEnvData({ ...envData, [e.target.name]: val, error: val ? false : true });
                }
            }
            else {
                setEnvData({ ...envData, [e.target.name]: val, error: val ? false : true });
            }
        }
        form.setFieldValue(e.target.name, val);
        setError({ ...error, status: false });
    }

    function toggleAlert(type, message, description) {
        set_alertOptions(alertOptions => ({
            status: true,
            type: type,
            message: message,
            description: description,
        }));

        setTimeout(() => {
            set_alertOptions(alertOptions => ({
                status: false,
                type: type,
                message: message,
                description: description,
            }));
        }, 5 * 1000);
    }

    const handelCreate = async (e, addAnother) => {
        console.log("inside handelCreate envData:", envData);
        try {
            if (form) {
                const values = await form.validateFields();
                console.log('Success:', values);
            }
            let allNames = [];
            console.log("My service: ", service);
            if (data) {
                data.map((temp) => {
                    allNames.push(temp.varName);
                });
            }

            if (allNames.includes(envData.varName)) {
                setError({
                    status: true,
                    msg: "Variable name already exist. Please provide unique variable name."
                });
                form.setFields([{
                    name: "varName",
                    errors: ["Variable name already exist. Please provide unique variable name."]
                }]);
            }
            else if (envData.varName.startsWith(" ") || envData.varName.endsWith(" ")) {
                setError({
                    status: true,
                    msg: "Please remove any leading or trailing spaces from variable name."
                });
            }
            else {
                setError({ ...error, status: false });

                console.log("data while add: ", data);
                console.log("envData while add: ", envData);
                
                // Set importFrom for secrets
                if (envData.isSecret && hasSecretManager) {
                    envData.importFrom = "Secret Manager";
                }

                data.push(envData);
                console.log("updated data while add: ", data);

                setEnvVarsList([...data]);

                toggleAlert("success", "Success", "Environment variable added successfully.");

                if (addAnother) {
                    setEnvData({
                        varName: "",
                        valueFrom: fromWorkflow ? "Value" : "",
                        value: "",
                        isSecret: envData.isSecret,
                        isHide: true,
                        dependOn: "",
                        value_depend_on: "",
                        error: false,
                        originalKey: "",
                        lastAction: "",
                        importFrom: "",
                        syncProj: false,
                        injectAt: fromWorkflow ? ["Build Time"] : []
                    });
                }
                else {
                    console.log("my click");
                    handelClick();
                }
            }
        }
        catch (err) {
            console.log("Inside handelCreate Error :", err);
        };
    }

    const handelUpdate = async (e) => {
        console.log("inside handelUpdate envData:", service, envData, data);
        try {
            if (form) {
                const values = await form.validateFields();
                console.log('Success:', values);
            }
            let allNames = [];
            let ctr = 0; //counts how many times the variables get repeated

            allData.map((temp) => {
                // check if the key of the variable was changed. 
                // If it gets changed, compare the variables with varName(updated key) for variables and original key for the edited variable.
                if (temp.varName != envData.varName && temp.varName !== envData.originalKey) {
                    allNames.push(temp.varName);
                }
                else {
                    allNames.push(temp.varName);
                    ctr++;
                }
            });

            console.log("ALL NAMES: ", allNames, allNames.includes(envData.varName), ctr);

            if (allNames.includes(envData.varName) && ctr > 1) {
                setError({
                    status: true,
                    msg: "Variable name already exist. Please provide unique variable name."
                });
                form.setFields([{
                    name: "varName",
                    errors: ["Variable name already exist. Please provide unique variable name."]
                }]);
            }
            else if (envData.varName.startsWith(" ") || envData.varName.endsWith(" ")) {
                setError({
                    status: true,
                    msg: "Please remove any leading or trailing spaces from variable name."
                });
            }
            else {
                setError({ ...error, status: false });
                console.log("Data.tempId: ", data);

                // Update importFrom for secrets
                if (envData.isSecret && hasSecretManager) {
                    envData.importFrom = "Secret Manager";
                }

                // update env_var here
                console.log("data while update: ", data);
                console.log("envData while update: ", envData);
                allData[data.id] = { ...envData, lastAction: "Update" };

                console.log("updated allData while update: ", allData);

                setEnvVarsList([...allData]);

                toggleAlert("success", "Success", "Environment variable updated successfully.");

                handelClick();
            }
        }
        catch (err) {
            console.log("Inside handelUpdate Error :", err);
        }
    }

    return (
        <ProdContentHold className='addEnvVar' style={{}}>
            {console.log("My env var data: ", envData, "accountDetails: ", accountDetails, "hasSecretManager: ", hasSecretManager)}
            <div title={(!hasPermission('update_secret') && update && envData.isSecret) && "You don't have permission to perform this action."}>
                <Form
                    form={form}
                    initialValues={{ ...envData }}
                    preserve={false}
                    name="dynamic_rule"
                    disabled={(!hasPermission('update_secret') && update && envData.isSecret)}
                >
                    <Box
                        title={<div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}>
                            <span className="header-text">{update ? "Update Variable" : "Add Variable"}</span>
                            <img src={closeIcon} style={{ cursor: "pointer", width: "20px", height: "20px", transform: "translateY(15px)" }} alt="close Icon" onClick={handelClick} />
                        </div>}
                        subtitle={update ? "Update environment variable details" : "Enter details to add new variable"}
                        titleStyle={{
                            fontWeight: '500',
                            fontFamily: "Nunito Sans",
                            fontSize: '14px',
                            color: "white"
                        }}
                        subTitleStyle={{
                            fontWeight: '400',
                            fontFamily: "Nunito Sans",
                            fontSize: '13px',
                            color: "white"
                        }}
                        style={{
                            position: "absolute",
                            zIndex: "1",
                            width: "100%",
                            top: "0px",
                            height: "83px",
                            backgroundColor: "rgb(19, 47, 68)"
                        }}
                    />

                    <Box
                        title="Variable*"
                        subtitle="Variable Name"
                        titleStyle={titleStyle}
                        subtitleStyle={subTitleStyle}
                        style={{
                            marginTop: "80px",
                        }}
                    >
                        <Form.Item
                            name="varName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter variable name',
                                }
                            ]}
                            style={{ marginBottom: "0" }}
                        >
                            <Input
                                name="varName"
                                value={envData.varName}
                                onChange={handelInputChange}
                                placeholder="Enter Variable here"
                                className="envVar-varName"
                                style={{ height: "44px" }}
                                disabled={(!hasPermission('update_secret') && update && envData.isSecret)}
                            />
                        </Form.Item>
                    </Box>

                    {envData.type && <Box
                        title="Type*"
                        subtitle="Variable type"
                        titleStyle={titleStyle}
                        subtitleStyle={subTitleStyle}
                        style={{
                            marginTop: "0px",
                        }}
                    >
                        <Input
                            name="type"
                            value={envData.type}
                            onChange={handelInputChange}
                            placeholder="Enter Variable here"
                            className="envVar-varName"
                            style={{ height: "44px" }}
                            disabled={true}
                        />
                    </Box>}

                    <Box
                        title="Value*"
                        subtitle="Please enter a value"
                        subtitleStyle={subTitleStyle}
                        titleStyle={titleStyle}
                    >
                        <Form.Item
                            name="value"
                            rules={[
                                {
                                    required: true,
                                    message: 'This field is required!',
                                },
                                {
                                    validator: (_, value) => {
                                        console.log("envData :", envData);
                                        console.log("type :", type);
                                        console.log("value :", value);

                                        if (type === "terraform" && envData.type) {
                                            if (envData.type === "map(string)" && isValidMapString(value)) {
                                                return Promise.resolve();
                                            }
                                            else if (envData.type === "list(string)" && isValidListString(value)) {
                                                return Promise.resolve();
                                            }
                                            else if (envData.type === "map(any)" && isValidMapAny(value)) {
                                                return Promise.resolve();
                                            }
                                            else if (envData.type === "any") {
                                                return Promise.resolve();
                                            }
                                            else if (envData.type === "bool" && isValidBool(value)) {
                                                return Promise.resolve();
                                            }
                                            else if (!["map(any)", "map(string)", "any", "list(string)"].includes(envData.type)) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('Value is not matching the type specified.'));
                                        }
                                        else{
                                            return Promise.resolve();
                                        }
                                    }
                                },
                            ]}
                        >
                            <TextArea
                                rows={4}
                                name="value"
                                value={envData.value}
                                onChange={handelInputChange}
                                placeholder="Enter value here"
                                className="envVar-textarea"
                                disabled={(!hasPermission('update_secret') && update && envData.isSecret)}
                            />
                        </Form.Item>
                    </Box>

                    <Box
                        title={<div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                            <div style={{ display: "flex" }}>
                                <span style={{ marginRight: "10px" }}>Is this a secret* </span>
                                <CustomInfoTooltip title={"Note: any new secret or modification to existing secrets will sync back to the provider."} placement="bottomLeft" />
                            </div>
                            {console.log("Has permission check...", (!hasPermission('create_secret') || (!hasPermission('update_secret') && update)) && data.isSecret)}
                            <Switch
                                checked={envData.isSecret}
                                onChange={(checked) => {
                                    // Check if we can toggle secret based on accountDetails
                                    const canToggle = !((hasSecretManager && data.isSecret && update) || envData.valueFrom === "Value From" || hasChanges);
                                    if (canToggle) {
                                        setEnvData({ 
                                            ...envData, 
                                            syncProj: false, 
                                            isSecret: !envData.isSecret, 
                                            isHide: !envData.isSecret,
                                            importFrom: (!envData.isSecret && hasSecretManager) ? "Secret Manager" : ""
                                        });
                                        setError({ ...error, status: false });
                                    }
                                }}
                                name="isSecret"
                                title={
                                    (((!hasPermission('create_secret') && !update) || (!hasPermission('update_secret') && update && data.isSecret))) ? 
                                        "You don't have permission to perform this action." : 
                                        ((hasSecretManager && data.isSecret && update) || envData.valueFrom === "Value From" || hasChanges) ? 
                                            "Please save the existing variables first." : 
                                            ""
                                }
                                disabled={
                                    ((!hasPermission('create_secret') && !update) || 
                                    (!hasPermission('update_secret') && update && data.isSecret)) ||
                                    ((hasSecretManager && data.isSecret && update) || envData.valueFrom === "Value From" || hasChanges)
                                }
                                style={{ 
                                    backgroundColor: envData.isSecret && "#132f44", 
                                    opacity: ((hasSecretManager && data.isSecret && update) || envData.valueFrom === "Value From" || hasChanges) && "0.7", 
                                    cursor: ((hasSecretManager && data.isSecret && update) || envData.valueFrom === "Value From" || hasChanges) && "default" 
                                }}
                            /></div>}
                        subtitle="Toggle the switch to enable secret variable."
                        titleStyle={titleStyle}
                        subtitleStyle={subTitleStyle}
                    >
                    </Box>

                    <div style={{ height: "150px" }}></div>

                    <div style={{
                        position: "absolute",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "84px",
                        bottom: "0",
                        borderTop: "1px solid #e9e9e9",
                        zIndex: "1000",
                        background: "white",
                    }}>
                        {!update ?
                            <Button style={{
                                padding: '10px 50px',
                                backgroundColor: "#132F44",
                                width: "164px",
                                height: "44px",
                                border: '1px solid #D9D9D9',
                                borderRadius: '8px',
                                color: "white",
                                marginRight: "15px"
                            }}
                                onClick={(e) => {
                                    handelCreate(e, false);
                                }}
                            >Create</Button>
                            :
                            <Button style={{
                                padding: '10px 50px',
                                backgroundColor: "#132F44",
                                width: "164px",
                                height: "44px",
                                border: '1px solid #D9D9D9',
                                borderRadius: '8px',
                                color: "white",
                            }}
                                onClick={handelUpdate}
                            >Update</Button>
                        }

                        {!update && <Button style={{
                            padding: '10px 14px',
                            backgroundColor: "transparent",
                            width: "188px",
                            height: "44px",
                            border: '1px solid #132F44',
                            borderRadius: '8px',
                            color: "#132F44"
                        }}
                            onClick={(e) => {
                                handelCreate(e, true);
                            }}
                        >Create & Add another</Button>}
                    </div>
                </Form>
            </div>
        </ProdContentHold>
    );
};

